import type { IncludeInfoInterface } from '@nts/std/interfaces';
import { Expose, Type } from '@nts/std/serialization';

export class IncludeInfo implements IncludeInfoInterface {

    @Expose()
    propertyName: string;

    @Expose()
    entityName: string;

    @Expose()
    includeColumns: boolean;

    @Expose()
    @Type(() => IncludeInfo)
    includes: Array<IncludeInfoInterface>;

    static flatten(include: IncludeInfo): Array<IncludeInfo> {

        const incls = new Array<IncludeInfo>();
        if (include.includes != null && include.includes.length > 0) {
            include.includes.forEach(i => {
                incls.push(i);
            });
        }

        return incls;
    }

    constructor() {
        this.includes = new Array<IncludeInfo>();
    }

}
